import { render, staticRenderFns } from "./ContractModalSettingsTab.vue?vue&type=template&id=1ac65138&"
import script from "./ContractModalSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ContractModalSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports